function pendingWithdrawBox(withdraw) {
	return `<div style="padding: 5px; flex: 1 1 auto; margin: auto; min-width: 140px; min-height: 140px; outline: 2px solid blue;">
				<span>Amount</span> <span>${withdraw.amount}</span> <span>${withdraw.currency}</span>
			</div>
		`;
}
function boxContainer(withdrawBoxes) {
	return `<div style="display: flex; flex-direction: row;">${withdrawBoxes}</div>
		`;
}

function getPendingWithdrawContent(pendingWithdraws) {
	const withdrawBoxes = pendingWithdraws.map(pendingWithdrawBox);
	return new Promise((resolve, reject) => {
		try {
			resolve(boxContainer(withdrawBoxes.join('')));
		} catch (e) {
			reject(e);
		}
	});
}

export {
	getPendingWithdrawContent
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/withdraw/cancel-pending-withdraw.js